// client/src/context/AuthContext.js

import React, { createContext, useState, useEffect, useContext } from 'react';
import { checkLogin, login as apiLogin, logout as apiLogout } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const verifySession = async () => {
            setIsLoading(true);
            try {
                const data = await checkLogin();
                if (data.loggedIn) {
                    setUser(data.user);
                }
            } catch (error) {
                setUser(null);
            } finally {
                setIsLoading(false);
            }
        };
        verifySession();
    }, []);

    // ✅ This login function now handles the API call and sets the state
    const login = async (credentials) => {
        try {
            const data = await apiLogin(credentials);
            if (data.success) {
                setUser(data.user);
            }
            return data; // Return the full response for the page to use
        } catch (error) {
            // Rethrow the error so the login page can catch it
            throw error;
        }
    };

    const logout = async () => {
        try {
            await apiLogout();
        } finally {
            setUser(null); // Always clear the user state
        }
    };

    const value = { user, isLoading, login, logout };

    return (
        <AuthContext.Provider value={value}>
            {!isLoading && children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};